import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useUpdateEmployeeExperienceDetails(
  closeModal,
  iscloseModalTrue,
  defaultValues,
  reset
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.EMPLOYEE_PROFESSIONAL_EXPERIENCE,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data.message });
        if (iscloseModalTrue) {
          closeModal();
        } else {
          reset(defaultValues);
        }
        queryClient.invalidateQueries('get-employee-professional-info');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
